// src/services/matchService.js
import axiosInstance from "../api/axiosInstance"; // ✅ your configured axios instance

// Example if axiosInstance has baseURL = '/admin/match-discovery'
export const fetchInteractions = (params) =>
  axiosInstance.get("/admin/interactions", { params });
export const fetchInteractionById = (id) =>
  axiosInstance.get(`/admin/interactions/${id}`);
export const deleteInteraction = (id) =>
  axiosInstance.delete(`/admin/interactions/${id}`);
export const deleteInteractionBulk = (payload) =>
  axiosInstance.post("/admin/interactions/deleteBulk", payload);
export const fetchMatchStatus = (params) =>
  axiosInstance.get("/admin/match-status", { params });
export const postMatchOverride = (payload) =>
  axiosInstance.post("/admin/match-override", payload);

export const unlockVaultManual = (payload) =>
  axiosInstance.post("/admin/vault/unlock", payload);

export const fetchVaultUnlockDetails = (userId, matchedUserId) => {
  return axiosInstance.get(`/admin/vault-unlocks/${userId}/${matchedUserId}`);
};

// "Add a line" (2026-10-08): every typed Vault line between the two, live and
// removed, and every refused one (backend utils/vaultLine adminListForPair).
export const fetchVaultLines = (userId, matchedUserId) => {
  return axiosInstance.get(`/admin/vault-lines/${userId}/${matchedUserId}`);
};